import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Alert } from "@material-ui/lab";
import { Helmet } from "react-helmet-async";
import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import ExchangePairsEditForm from "./ExchangePairsEditForm";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import Notification from "../../../elements/notification/Notification";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";

import { StyledFeeDetailsWrapper } from "../../../fee/styledFee";
import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../../styles/styledTabsForm";

const ExchangePairsDetailsContainer = ({ match }) => {
  const { t } = useTranslation("exchangerPage");

  const [pair, setPair] = useState();

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/exchange-pairs/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setPair(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  if (!pair) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (pair.length === 0) {
    return <Alert severity="warning">{t("pairs.details.changeForm.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("pairs.details.meta.title")} {pair.inService.name} {pair.inCurrency.asset} - {pair.outService.name} {pair.outCurrency.asset} • eXsoft.io</title>
        </Helmet>
        <StyledFeeDetailsWrapper>
          <GoToBackButton
            handler={() => {history.goBack();}}
            pt="20"
            pb="30"
          />
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("pairs.details.changeForm.give")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("pairs.details.changeForm.inService")}
                  type="text"
                  value={getServiceNameWithNickname(pair.inService.name, pair.inService.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("pairs.details.changeForm.inCurrency")}
                  type="text"
                  value={pair.inCurrency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("pairs.details.changeForm.receive")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("pairs.details.changeForm.outService")}
                  type="text"
                  value={getServiceNameWithNickname(pair.outService.name, pair.outService.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("pairs.details.changeForm.outCurrency")}
                  type="text"
                  value={pair.outCurrency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("pairs.details.changeForm.fee")}
              </StyledBlockLabel>
              <ExchangePairsEditForm
                t={t}
                pair={pair}
                notification={notification}
                setNotification={setNotification}
              />
              <div className="clear-column" />
            </StyledFormBlock>
          </StyledFormGrid>
        </StyledFeeDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
}

export default ExchangePairsDetailsContainer;